function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 136.22,
  cy: 136.84,
  rx: 29.06,
  ry: 17.43,
  transform: "rotate(-20 78.846 196.874)"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 56,
  cy: 144.82,
  rx: 29.11,
  ry: 17.46,
  transform: "rotate(-20 -1.36 204.865)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M60 122.56V32l80.09-28v112.06"
});

var SvgRankVirtuoso = function SvgRankVirtuoso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 144.18 152.02",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgRankVirtuoso;